import React from 'react';
import { SxStyle } from '../../../types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { EditableBottomBarItem, MenuItemEditableKeys } from './types';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import AppMenuItemSortable from './item/app-menu-item-sortable';
import { AnySchema } from 'yup';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    padding: 1,
    paddingTop: 2,
  },
  content: {
    paddingTop: 2,
  },
};

interface Props {
  contextId: string;
  title: string;
  subTitle: string;
  bottomBarItems: EditableBottomBarItem[];
  startItem?: React.ReactNode;
  expandedIds: number[];
  onExpanded: (isExpanded: boolean, menuItem: EditableBottomBarItem) => void;
  onDelete: (menuItem: EditableBottomBarItem) => void;
  onValue: (key: MenuItemEditableKeys, value: any | null, menuItem: EditableBottomBarItem) => void;
  onValidation: (key: string, isValid: boolean, schema?: AnySchema) => void;
}

const AppMenuSortableContext = ({
  contextId,
  title,
  subTitle,
  bottomBarItems,
  expandedIds,
  onExpanded,
  onDelete,
  onValue,
  onValidation,
  startItem = null,
}: Props) => {
  return (
    <Stack spacing={1} flex={2} width="100%">
      <Box sx={styles.title}>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="caption">{subTitle}</Typography>
      </Box>
      <Stack sx={styles.content} spacing={1}>
        {startItem}
        <SortableContext
          items={bottomBarItems}
          strategy={verticalListSortingStrategy}
          id={contextId}
        >
          {bottomBarItems.map((menuItem, index) => (
            <AppMenuItemSortable
              bottomBarItem={menuItem}
              position={index + 2}
              key={menuItem.id}
              id={menuItem.id}
              isExpanded={expandedIds.includes(menuItem.id)}
              onExpanded={(isExpanded) => onExpanded(isExpanded, menuItem)}
              onDelete={onDelete}
              onValue={(key, value) => onValue(key, value, menuItem)}
              onValidation={onValidation}
            />
          ))}
        </SortableContext>
      </Stack>
    </Stack>
  );
};

export default AppMenuSortableContext;
